import { Form, message } from 'antd'
import { Props } from '.'
import {
  reducer,
  initialState,
  setPaginationOptionAction,
  setDataSourceAction,
  setSelectedRowsAction,
  setSelectedRowKeysAction,
  setSearchParamsAction,
  setIsTicketRelationModalOpenAction,
  setSelectedRowKeysFormAction,
  setSelectedRowsFormAction,
} from './reducer'
import { useEffect, useMemo, useReducer } from 'react'
import { isResponseSuccess } from '@/tools'
import { EMPTY_ARRAY } from '@/global/config'
import { BrandInfoVO, GET_PAGE_BRAND_POOL, GetBrandPoolParam } from '@/api/dock'
export function getRowKey(record: any) {
  return record.brandCode
}
export type FormFields = Pick<GetBrandPoolParam, 'brandCode' | 'brandName'>
export function useSetupHook(props: Props) {
  const [form] = Form.useForm()
  const {
    value = EMPTY_ARRAY,
    onChange,
    platformCode,
    postOnChange,
    categoryCode,
  } = props
  const [state, dispatch] = useReducer(reducer, initialState)
  const {
    searchParams,
    paginationOption,
    isTicketRelationModalOpen,
    selectedRows,
    selectedRowKeys,
    selectedRowKeysForm,
  } = state

  async function getPageData(
    params: Omit<GetBrandPoolParam, 'platformCode' | 'categoryCode'>,
  ) {
    const res = await GET_PAGE_BRAND_POOL({
      ...params,
      platformCode,
      // categoryCode: categoryCode || undefined, // 传递 categoryCode 参数
    })
    if (isResponseSuccess(res)) {
      const filteredData = res.data.content
      dispatch(setDataSourceAction(filteredData))
      dispatch(
        setPaginationOptionAction({
          pageSize: res.data.pageSize,
          pageNo: res.data.pageNo,
          totalCount: res.data.totalCount,
        }),
      )
    } else {
      message.error(res.msg)
    }
  }
  async function handlePaginationChange(page: number, pageSize?: number) {
    getPageData({
      ...searchParams,
      pageNo: page,
      pageSize: pageSize || paginationOption.pageSize,
    })
  }
  useEffect(() => {
    if (isTicketRelationModalOpen) {
      handleRefreshPage()
    }

    return () => {}
  }, [isTicketRelationModalOpen])
  function showTicketRelationModal() {
    dispatch(setIsTicketRelationModalOpenAction(true))
  }
  function cancelTicketRelationModal() {
    dispatch(setIsTicketRelationModalOpenAction(false))
  }

  function handleTableChangeCheck(
    selectedRowKeys: React.Key[],
    selectedRows: any[],
    info: {
      type: any
    },
  ) {
    dispatch(setSelectedRowsAction(selectedRows))
    dispatch(setSelectedRowKeysAction(selectedRowKeys))
  }
  function handleTableChangeCheckForm(
    selectedRowKeys: React.Key[],
    selectedRows: any[],
    info: {
      type: any
    },
  ) {
    dispatch(setSelectedRowsFormAction(selectedRows))
    dispatch(setSelectedRowKeysFormAction(selectedRowKeys))
  }

  function resetSelection() {
    handleTableChangeCheck([], [], { type: '' })
  }
  function resetSelectionForm() {
    handleTableChangeCheckForm([], [], { type: '' })
  }
  async function hanleSearch() {
    const formVales = form.getFieldsValue()
    const searchValues = {
      ...formVales,
      remainingAmount: formVales?.remainingAmount?.num,
      remainingAmountCondition: formVales?.remainingAmount?.operator,
    }
    await getPageData({
      ...searchValues,
      pageNo: 1,
      pageSize: paginationOption.pageSize,
    })
    dispatch(setSearchParamsAction(searchValues))
  }
  async function handleRefreshPage() {
    resetSelection()
    await getPageData({
      pageNo: 1,
      pageSize: paginationOption.pageSize,
    })
  }
  async function handleReset() {
    form.resetFields()
    await handleRefreshPage()
  }

  const showBrandSelectModal = () => {
    dispatch(setIsTicketRelationModalOpenAction(true))
  }

  const cancelBrandSelectModal = () => {
    dispatch(setIsTicketRelationModalOpenAction(false))
  }

  function onRowClick(record: BrandInfoVO) {
    onChange?.(`${record.brandName}/${record.brandCode}`, record)
    postOnChange?.(record)
    cancelBrandSelectModal()
  }
  return {
    state,
    form,
    value,
    cancelTicketRelationModal,
    handlePaginationChange,
    handleTableChangeCheck,
    hanleSearch,
    handleRefreshPage,
    showTicketRelationModal,
    handleReset,
    handleTableChangeCheckForm,
    showBrandSelectModal,
    onRowClick,
  }
}
import { Form, message } from 'antd'
import { Props } from '.'
import {
  reducer,
  initialState,
  setPaginationOptionAction,
  setDataSourceAction,
  setSelectedRowsAction,
  setSelectedRowKeysAction,
  setSearchParamsAction,
  setIsTicketRelationModalOpenAction,
  setSelectedRowKeysFormAction,
  setSelectedRowsFormAction,
} from './reducer'
import { useEffect, useMemo, useReducer } from 'react'
import { isResponseSuccess } from '@/tools'
import { EMPTY_ARRAY } from '@/global/config'
import { BrandInfoVO, GET_PAGE_BRAND_POOL, GetBrandPoolParam } from '@/api/dock'
export function getRowKey(record: any) {
  return record.brandCode
}
export type FormFields = Pick<GetBrandPoolParam, 'brandCode' | 'brandName'>
export function useSetupHook(props: Props) {
  const [form] = Form.useForm()
  const {
    value = EMPTY_ARRAY,
    onChange,
    platformCode,
    postOnChange,
    categoryCode,
  } = props
  const [state, dispatch] = useReducer(reducer, initialState)
  const {
    searchParams,
    paginationOption,
    isTicketRelationModalOpen,
    selectedRows,
    selectedRowKeys,
    selectedRowKeysForm,
  } = state

  async function getPageData(
    params: Omit<GetBrandPoolParam, 'platformCode' | 'categoryCode'>,
  ) {
    const res = await GET_PAGE_BRAND_POOL({
      ...params,
      platformCode,
      // categoryCode: categoryCode || undefined, // 传递 categoryCode 参数
    })
    if (isResponseSuccess(res)) {
      const filteredData = res.data.content
      dispatch(setDataSourceAction(filteredData))
      dispatch(
        setPaginationOptionAction({
          pageSize: res.data.pageSize,
          pageNo: res.data.pageNo,
          totalCount: res.data.totalCount,
        }),
      )
    } else {
      message.error(res.msg)
    }
  }
  async function handlePaginationChange(page: number, pageSize?: number) {
    getPageData({
      ...searchParams,
      pageNo: page,
      pageSize: pageSize || paginationOption.pageSize,
    })
  }
  useEffect(() => {
    if (isTicketRelationModalOpen) {
      handleRefreshPage()
    }

    return () => {}
  }, [isTicketRelationModalOpen])
  function showTicketRelationModal() {
    dispatch(setIsTicketRelationModalOpenAction(true))
  }
  function cancelTicketRelationModal() {
    dispatch(setIsTicketRelationModalOpenAction(false))
  }

  function handleTableChangeCheck(
    selectedRowKeys: React.Key[],
    selectedRows: any[],
    info: {
      type: any
    },
  ) {
    dispatch(setSelectedRowsAction(selectedRows))
    dispatch(setSelectedRowKeysAction(selectedRowKeys))
  }
  function handleTableChangeCheckForm(
    selectedRowKeys: React.Key[],
    selectedRows: any[],
    info: {
      type: any
    },
  ) {
    dispatch(setSelectedRowsFormAction(selectedRows))
    dispatch(setSelectedRowKeysFormAction(selectedRowKeys))
  }

  function resetSelection() {
    handleTableChangeCheck([], [], { type: '' })
  }
  function resetSelectionForm() {
    handleTableChangeCheckForm([], [], { type: '' })
  }
  async function hanleSearch() {
    const formVales = form.getFieldsValue()
    const searchValues = {
      ...formVales,
      remainingAmount: formVales?.remainingAmount?.num,
      remainingAmountCondition: formVales?.remainingAmount?.operator,
    }
    await getPageData({
      ...searchValues,
      pageNo: 1,
      pageSize: paginationOption.pageSize,
    })
    dispatch(setSearchParamsAction(searchValues))
  }
  async function handleRefreshPage() {
    resetSelection()
    await getPageData({
      pageNo: 1,
      pageSize: paginationOption.pageSize,
    })
  }
  async function handleReset() {
    form.resetFields()
    await handleRefreshPage()
  }

  const showBrandSelectModal = () => {
    dispatch(setIsTicketRelationModalOpenAction(true))
  }

  const cancelBrandSelectModal = () => {
    dispatch(setIsTicketRelationModalOpenAction(false))
  }

  function onRowClick(record: BrandInfoVO) {
    onChange?.(`${record.brandName}/${record.brandCode}`, record)
    postOnChange?.(record)
    cancelBrandSelectModal()
  }
  return {
    state,
    form,
    value,
    cancelTicketRelationModal,
    handlePaginationChange,
    handleTableChangeCheck,
    hanleSearch,
    handleRefreshPage,
    showTicketRelationModal,
    handleReset,
    handleTableChangeCheckForm,
    showBrandSelectModal,
    onRowClick,
  }
}
